<script setup lang="ts">
import {Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger} from "@/core/components/ui/dialog";
import EmbedVideo from "@/core/components/video/EmbedVideo.vue";

defineProps<{
    title: string;
    embedVideoUrl: string
}>();
</script>

<template>
  <Dialog>
    <DialogTrigger as-child>
      <slot />
    </DialogTrigger>
    <DialogContent class="min-w-[60%]">
      <DialogHeader>
        <DialogTitle>
          {{ title }}
        </DialogTitle>
      </DialogHeader>
      <EmbedVideo :url="embedVideoUrl" class="w-full" />
    </DialogContent>
  </Dialog>
</template>
